import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'

const moduleId = 25

const getAlertModule = (user) => {
  const adminModule = user?.profile?.adminModules?.find(m => m.moduleId === moduleId)
  const alertModule = user?.profile?.modules?.alert
  const legacyAccess = !!adminModule?.isAccess
  const isAccess = !!(alertModule?.isAccess ?? legacyAccess)

  return {
    ...alertModule,
    isAccess,
    builderAccess: !!(alertModule?.builderAccess ?? isAccess),
    monitorAccess: !!(alertModule?.monitorAccess ?? isAccess),
  }
}

export const canUserAccessAlertBuilder = (user = useUserStore().user) => !!user && getAlertModule(user).builderAccess

export const canUserAccessModule = (user = useUserStore().user) => {
  if (!user) return false
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  const alertModule = getAlertModule(user)
  return isFirmAccess && alertModule.isAccess
}

export const guardBuilder = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const alert = getAlertModule(user)
  return alert.builderAccess ? alert.builderAccess : { name: 'Home' }
}

export const guardMonitor = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const alert = getAlertModule(user)
  return alert.monitorAccess ? alert.monitorAccess : { name: 'Home' }
}

export const guardAlertAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}
